// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from "vue-router";
import routers from './router/routers';
import ElementUI from 'element-ui';
import components from './components/index';
import '../theme/index.css';
import '../static/font/font.css';
import '../static/css/common.css';
import './icons';
import App from './App';
import axios from 'axios'
import store from './vuex/store'
import Print from 'vue-print-nb'
import echarts from 'echarts';
import 'echarts/theme/macarons.js';
import VueClipboard from 'vue-clipboard2'
import utiljs from '../static/js/utils'
import {baseUrl} from '../config/env'
import ElementResizeDetectorMaker from "element-resize-detector"
import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css';
import './common/utils/dialogDrag.js'

//addon
import './addon/global/global.js';

// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(VueIntro);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(components);
Vue.use(Print);
Vue.use(VueClipboard);
Vue.prototype.$erd = ElementResizeDetectorMaker()
Vue.prototype.$echarts = echarts;
Vue.prototype.global = {baseurl: baseUrl}
Vue.prototype.$axios = axios
var qs = require("querystring")
axios.defaults.baseURL = baseUrl;
// // 2020/06/22
// axios.defaults.withCredentials = true;  //允许axios请求携带cookie等凭证

Vue.directive('focus', {
  inserted: function(el) {
    // 聚焦元素 如果元素配合modal使用 则需要给元素添加v-if
    el.querySelector('input').focus();
  }
});


// $.ajaxPrefilter(function (options){
//   //设置默认参数，用于初始化菜单接口权限数据
//   options.data.append('basePagePath',window.location.pathname)
// })
axios.interceptors.request.use((req) => {
  // //设置默认参数，用于初始化菜单接口权限数据
  // if(req.data){
  //   req.data.basePagePath = window.location.pathname;
  // }else{
  //   req.data = {'basePagePath':window.location.pathname};
  // }
  if (req.method === 'post' && req.url.indexOf("upload") === -1) {
    req.data = qs.stringify(req.data);
  }
  return req;
}, (error) => Promise.reject(error));

let webUrl = "http://localhost:8081/login";//本地地址
if (process.env.NODE_ENV === 'test') {
  webUrl = "http://129.204.68.217:8088/sthpc/#/login";//测试地址
  var router = new VueRouter({
    // mode: 'history',//部署时关闭
    base: __dirname,
    linkActiveClass: 'active',
    routes: routers,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return { x: 0, y:0 };
    },
  });
} else if (process.env.NODE_ENV === 'production') {
  webUrl = "https://service.stonghr.cn/sth/#/login";//正式地址
  var router = new VueRouter({
    // mode: 'history',//部署时关闭
    base: __dirname,
    linkActiveClass: 'active',
    routes: routers,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return {x: 0, y: 0};
    },
  });
} else {
  var router = new VueRouter({
    mode: 'history',//部署时关闭
    base: __dirname,
    linkActiveClass: 'active',
    routes: routers,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta.keepAlive) {
        return savedPosition;
      }
      return { x: 0, y:0 };
    },
  });
}
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  store.commit('showSensitiveData');
  next()
})

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  console.log(isChunkLoadFailed, '/Loading chunk (\d)+ failed/g', '路由懒加载找不到对应的moudle')
  if (isChunkLoadFailed) {
    window.location.reload();
  } else {
    console.log(error)
  }
});

var myInterceptor = axios.interceptors.response.use(function (res) {
  // 对响应数据做点什么
  if (res.data.flag == 'overdue') {
    location.href = webUrl
  } else if (res.data.flag == 'overOperation'){
    alert(res.data.message);
  } else if (res.data.flag == 'ipInvalid'){
    location.href = webUrl
  }else {
    return res;
  }
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.prototype.$http = axios
Vue.prototype.$utils = utiljs
Vue.prototype.qs = qs;

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: {App},
  template: '<App/>'
});





// WEBPACK FOOTER //
// ./src/main.js